import {
  JobType,
  type UserJob,
  type UserJobTitles,
} from '@/models/taxonomy/job';

export const transformJobs = (data: UserJob[]): UserJobTitles => {
  if (!data || !Array.isArray(data))
    return { current: undefined, desired: undefined };

  const currentJob = data.find(
    (item: UserJob) => item.job_type === JobType.Current
  )?.job_title;
  const desiredJob = data.find(
    (item: UserJob) => item.job_type === JobType.Desired
  )?.job_title;

  return { current: currentJob, desired: desiredJob };
};
